import { doc, getDoc } from "firebase/firestore";
import auth from "../firebase/auth";
import db from "../firebase/db";

export default async function ({ getters, commit, dispatch }) {
  try {
    const admin = await auth.currentUser
      .getIdTokenResult()
      .then((idTokenResult) => !!idTokenResult.claims.admin);

    let userData = await getDoc(doc(db, "users", auth.currentUser.uid));

    if (!userData.exists()) {
      await new Promise((resolve) => setTimeout(resolve, 5000));
      userData = await getDoc(doc(db, "users", auth.currentUser.uid));
    }

    if (userData.data() !== undefined) {
      const language = userData.data().language
        ? userData.data().language
        : navigator.language;

      await commit(
        "user/SET_USER",
        {
          title: userData.data().title ? userData.data().title : null,
          photoURL: userData.data().profilePictureUrl
            ? userData.data().profilePictureUrl
            : null,
          admin: admin,
          language: language,
        },
        { root: true }
      );

      auth.languageCode = language;
    } else {
      let language = navigator.language;
      if (getters["user/getUser"].language) {
        language = getters["user/getUser"].language;
      } else {
        commit(
          "user/SET_USER",
          {
            language: language,
          },
          { root: true }
        );
      }
      auth.languageCode = language;
    }

    await dispatch("membership/getMembershipFromFirebase", null, {
      root: true,
    });
  } catch (error) {
    commit("SET_INIT_ERROR", error);
  }
}
